import * as React from 'react'
import {useLocation} from 'react-router-dom'
import {Skeleton} from 'src/components/skeleton'
import {useNavigationMenu} from 'src/layouts/main-layout/app-sidebar/navigation/hooks/use-navigation-menu.hook'
import {AppSidebarNavItem} from './app-sidebar-nav-item'
import {useAppSidebar} from './app-sidebar-context'

export function AppSidebarNav() {
  const {data: menu, isLoading} = useNavigationMenu()
  const {collapsed, expandedItemId, setExpandedItemId} = useAppSidebar()
  const {pathname} = useLocation()
  const [hoverCardItemId, setHoverCardItemId] = React.useState<string | null>(null)

  const handleOpenChange = React.useCallback(
    (id: string, open: boolean) => {
      setExpandedItemId(open ? id : null)
    },
    [setExpandedItemId],
  )

  const handleHoverCardOpenChange = React.useCallback((id: string, open: boolean) => {
    setHoverCardItemId((prev) => (open ? id : prev === id ? null : prev))
  }, [])

  React.useEffect(() => {
    setHoverCardItemId(null)
  }, [collapsed, pathname])

  if (isLoading) {
    return (
      <nav data-slot='sidebar-nav' className='flex flex-col gap-3'>
        {Array.from({length: 5}).map((_, i) => (
          <Skeleton key={i} className='h-10 w-full' />
        ))}
      </nav>
    )
  }

  return (
    <nav data-slot='sidebar-nav' className='flex flex-col'>
      {menu?.map((navigationMenu) => (
        <AppSidebarNavItem
          key={navigationMenu.id}
          navigationMenu={navigationMenu}
          isOpen={expandedItemId === navigationMenu.id}
          onOpenChange={handleOpenChange}
          isHoverCardOpen={hoverCardItemId === navigationMenu.id}
          onHoverCardOpenChange={(open: boolean) => handleHoverCardOpenChange(navigationMenu.id, open)}
        />
      ))}
    </nav>
  )
}
